import React, { useState, useCallback, useRef, useEffect } from 'react';
import HttpService from '../services/httpService';
import {
  TextField, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper
} from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { getApprovedProjects } from '../redux/actions/financeAction';
import { CheckCircleOutlined } from '@ant-design/icons'
import ClearIcon from '@material-ui/icons/Clear';
import debounce from 'lodash/debounce'; // Import lodash debounce
import { CSVLink } from "react-csv";
import XLSX from 'xlsx';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
  boxContainer: {
    display: 'flex',
    gap: '10px',
    margin: '20px 0',
  }
}));
const ScanBarcode = (props) => {
  const buttonRef = useRef(null);
  const classes = useStyles();
  const { approvedProjects } = useSelector(state => state.finance);
  const [storeProjectDetails, setProjectDetails] = useState([]);
  const [downloadScannedBarcode,setDownlaodScannedBarcode] = useState([])
  const [mapScanDetails,setScanDetails] = useState([])
  const [projectScannedDetails, setProjectScannedDetails] = useState({
    totalNoOfPatterns: "",
    pendingNoOfPatterns: "",
    doneNoOfPatterns:""
  });  
  const [value, setValue] = useState('');
  const [loading, setLoadingState] = useState(false); // Loading state to prevent multiple calls
  const handleSelect = async (event, newValue) => {
    try {
      let res = await HttpService.getBomProjectDetails({ id: newValue?._id });
    // Assuming `res.data.patterns` is the array of patterns you receive from the API response
const patternsWithCheckbox = res.data.patterns.map((pattern) => pattern);
handleCountOfData (patternsWithCheckbox)
const createDataForDownloadPatternExcel = res.data.patterns
  .filter((el) => el.isBarcodeGenerated === true);
let result = [];
createDataForDownloadPatternExcel.forEach((el) => {
  const obj = {
    scopeName: el?.scopeId ? el?.scopeId?.name : null,
    spaceName: el?.spaceNameId ? el?.spaceNameId?.name : null,
    materialName: el?.materialId ? el?.materialId?.code : null,
    patternName: el?.start || null,
    patternId: el?._id,
    qty: 1,
    plyType: el?.plyType || '',
    laminateType: el?.laminateType || '',
    projectNo: res.data.project?.['code']
  };
  result.push(obj);
});
setDownlaodScannedBarcode(result)
     
let sortedPatterns = patternsWithCheckbox.sort((a, b) => {
    // If both have `scannedDate`, compare by date
    if (a.scannedDate && b.scannedDate) {
      return b.scannedDate - a.scannedDate;
    }
    
    // If only one has `scannedDate`, it should come first
    if (a.scannedDate && !b.scannedDate) {
      return -1; // `a` comes before `b`
    }
    if (!a.scannedDate && b.scannedDate) {
      return 1; // `b` comes before `a`
    }
    
    // If neither has `scannedDate`, maintain original order (or you can specify a different logic)
    return 0;
  });
  
      setScanDetails(sortedPatterns)
      setProjectDetails(res.data.project);
    } catch (error) {
      props.setSnackInfo("Something went wrong","error")
    
    }
  };
  const handleCountOfData = (patterns) => {
    let doneCount = 0;
    let pendingCount = 0;
    const totalCount = patterns.length;
  
    patterns.forEach(el => {
      if (el.isBarcodeGenerated === true) {
        doneCount++;
      } else {
        pendingCount++;
      }
    });
  
    
    setProjectScannedDetails(prevDetails => ({
      ...prevDetails,
      doneNoOfPatterns: doneCount,
      pendingNoOfPatterns: pendingCount,
      totalNoOfPatterns: totalCount
    }));
  };
  
  const textFieldRef = useRef(null);
  // Ensure the TextField is focused when the component mounts
  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, []);

  useEffect(() => {
    getApprovedProjects()
    // eslint-disable-next-line
  }, [])

  const getApprovedProjects = async () => {
    try {
      props.setLoading(true)
      await props.getApprovedProjects()
    }catch(error){
      props.setSnackInfo("Something went wrong","error")
    }
  }
  // Debounced function to handle barcode input change
  const handleBarcodeInputChange = useCallback(debounce(async (e) => {
    props.setLoading(true)
    const newValue = e.target.value;
    setValue(newValue);
    
    let obj = {
      patterns: newValue,
      projectId: storeProjectDetails['_id']
    };
    
    if (loading) return; // Prevent API call if already loading
    setLoadingState(true);
    try {
      let res = await HttpService.updateBarcodeScan([obj]);
      if (res.data.results[0]?.status === '201') {
        props.setSnackInfo("Barcode Already Scanned", 'warning');
        setValue(''); // Clear the input field
        handleSelect('',storeProjectDetails)
      }
      if(res.data.results[0]?.status === '200'){
        props.setSnackInfo("Barcode Generated Successfully", 'success');
        setValue(''); // Clear the input field
        handleSelect('',storeProjectDetails)
      }
      if(res.data.results[0]?.status === 'updated'){
        props.setSnackInfo("Barcode Generated Successfully", 'success');
        setValue(''); // Clear the input field
        handleSelect('',storeProjectDetails)
      }
    } catch (error) {
      props.setSnackInfo("Something went wrong","error");
      setValue(''); // Clear the input field
    } finally {
      setLoadingState(false); // Reset loading state
    }
    props.setLoading(false)
  }, 600), [storeProjectDetails, loading, props]);
  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBarcodeInputChange(e);
    }
  };
 

  const downloadExcel = () => {
    props.setLoading(true);

    try {
        // Create a new workbook and a new worksheet
        const workbook = XLSX.utils.book_new();

        // Convert data to JSON sheet with headers
        const worksheetData = downloadScannedBarcode.map((item) =>
            headers.reduce((acc, header) => {
                acc[header.label] = item[header.key];
                return acc;
            }, {})
        );

        // Create worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(worksheetData, {
            header: headers.map(header => header.label) // Use labels as the header row
        });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Scanned Laminate');

        // Create a filename based on the project details and current date
        const filename = `${storeProjectDetails?.code}_${storeProjectDetails?.clientName}_${moment(new Date()).format('DD-MM-YYYY')}_Scanned_Laminate.xlsx`;

        // Trigger the download of the Excel file
        XLSX.writeFile(workbook, filename);
        
    } catch (err) {
        console.error(err.message);
    } finally {
        props.setLoading(false);
    }
};

  const headers = [
    { key: "scopeName", label: "scope name" },
    { key: "spaceName", label: "space name" },
    { key: "materialName", label: "material name" },
    { key: "patternName", label: "pattern no" },
    { key: "patternId", label: "patternid" },
    { key: "qty", label: "quantity" },
    { key: "plyType", label: "ply_name" },
    { key: "laminateType", label: "laminate_name" },
  ]
  return (
    <div>
    <div className={classes.boxContainer}>
      <Autocomplete
        onChange={handleSelect}
        id="bom"
        options={approvedProjects}
        getOptionLabel={(option) => option.searchName || ''}
        style={{ width: 500 }}
        renderInput={(params) => <TextField {...params} label="Search Project" variant="outlined" />}
      />
      <TextField
          label="Scan Barcode"
          variant="outlined"
          style={{ width: 500 }}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress} // Handle Enter key press
          value={value} // Controlled component
          inputRef={textFieldRef} // Set the ref for focusing
        />
      <Button onClick={downloadExcel} style={{padding: "1rem 2rem 1rem 3rem", marginTop: "5px", marginLeft: "20px", background: "green", color: "white"}}>
          Download Scanned Laminate     
      </Button>
    </div>
    {mapScanDetails.length > 0 && (
        <div>
        Project Wise Scan Details
        <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
        <Table aria-label="knowledge details table">
        <TableHead>
        <TableRow>
        <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" , textAlign:"center" }}>Total Quantity</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" , textAlign:"center" }}>Pending</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" , textAlign:"center" }}>Done</TableCell>
          </TableRow>
          </TableHead>
          <TableBody>
     
          <TableRow>
          
            <TableCell  className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem", textAlign:"center",fontSize:"2rem" }}>{projectScannedDetails?.totalNoOfPatterns}</TableCell>
            <TableCell  className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem", textAlign:"center",fontSize:"2rem" }}>{projectScannedDetails?.pendingNoOfPatterns}</TableCell>
            <TableCell  className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem", textAlign:"center",fontSize:"2rem" }}>{projectScannedDetails?.doneNoOfPatterns}</TableCell>
            </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    )}
{mapScanDetails.length > 0  && (
<TableContainer component={Paper} style={{ marginTop: "1rem" }}>
<Table aria-label="knowledge details table">
  <TableHead>
    <TableRow>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Sl.No</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Status</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Space Name</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Scope Name</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Sub Category</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Material Name</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Unit Type</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>PLY <b style={{fontWeight:'900'}}>/</b> BOARD TYPE</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>LAMINATE - OSL / BSL</TableCell>
      <TableCell className={classes.tableCell} style={{ fontWeight: 800, padding: "1rem" }}>Pattern No</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {
    mapScanDetails.map((el,index)=>(
        <TableRow key={index}>
        <TableCell className={classes.tableCell}>{index + 1}</TableCell>
        <TableCell className={classes.tableCell}>{el.isBarcodeGenerated === true ? <CheckCircleOutlined style={{background:"green",fontSize:"30px",color:"#fff",borderRadius:"50%"}}/> : <ClearIcon style={{background:"orange",fontSize:"25px",color:"#fff",borderRadius:"50%"}}/>}</TableCell>
        <TableCell className={classes.tableCell}>{el.spaceNameId.name}</TableCell>
        <TableCell className={classes.tableCell}>{el.scopeId.name}</TableCell>
        <TableCell className={classes.tableCell}>{el.subCategoryId.name}</TableCell>
        <TableCell className={classes.tableCell}>{el.materialId.name}</TableCell>
        <TableCell className={classes.tableCell}>{el.unitType.name}</TableCell>
        <TableCell className={classes.tableCell}>{el?.plyType || 'NA'}</TableCell>
        <TableCell className={classes.tableCell}>{el?.laminateType || 'NA'}</TableCell>
        <TableCell className={classes.tableCell}>{el.start}</TableCell>
        </TableRow>
    ))
    }
  </TableBody>
</Table>
</TableContainer>
)}
</div>
  );
};
export default connect(null, { setLoading, setSnackInfo, getApprovedProjects })(ScanBarcode);